import { Routes, Route } from "react-router-dom";
import AppRoutes from "../AppRoutes";
import ManagerJourneyListingPage from "./ManagerJourneyListingPage";
import ManagerTaskListingPage from "./ManagerTaskListingPage";

function YourPeopleRoot() {
  // The `key` prop is there so that the component is re-mounted when the URL changes
  return (
    <>
      <Routes>
        <Route
          path={AppRoutes.yourPeople.sub.conversations.path}
          element={
            <ManagerJourneyListingPage
              formType="CONVERSATIONS"
              key="CONVERSATIONS"
            />
          }
        />
        <Route
          path={
            AppRoutes.yourPeople.sub.conversations.pathWithPreselectedEmployeeId
          }
          element={
            <ManagerJourneyListingPage
              formType="CONVERSATIONS"
              key="CONVERSATIONS-PRESELECT"
            />
          }
        />
        <Route
          path={AppRoutes.yourPeople.sub.pulseChecks}
          element={
            <ManagerJourneyListingPage
              formType="PULSE-CHECKS"
              key="PULSE-CHECKS"
            />
          }
        />

        <Route
          path={AppRoutes.yourPeople.sub.tasks.path}
          element={<ManagerTaskListingPage />}
        />
        <Route
          path={AppRoutes.yourPeople.sub.tasks.pathWithPreselectedEmployeeId}
          element={<ManagerTaskListingPage />}
        />
      </Routes>
    </>
  );
}

export default YourPeopleRoot;
